export default  {
  bindings: {
    offers: '<',
  },
  controller: 'offerListController',
  template: require('../views/offer.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/offer/components/offer.list.component.js